import { staticSelector } from 'ducks/static'
import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import {
  Container,
  Content,
  Title,
  Card,
  Left,
  LeftIconContainer,
  Icon,
  TextContainer,
  Info,
  Vector,
  Right,
  RightIconContainer,
  InfoOr,
  InfoGreen,
} from './styled'
import vector from 'assets/Vector6.png'

interface Props {
  result: string
  equivalentValue: string
  savedMoney: string
}

export const MetricsSubTab2: FC<Props> = ({ result, equivalentValue, savedMoney }) => {
  const state = useSelector(staticSelector)

  const { title, iconLeft, iconRight, textLeft, textRight } = state.content?.nationalMetric.subTabRender[1]

  return (
    <Container>
      <Content>
        {title ? <Title>{title}</Title> : null}
        <Card>
          <Left>
            <LeftIconContainer>{iconLeft.url ? <Icon src={iconLeft.url} /> : null}</LeftIconContainer>
            <TextContainer>
              {result && savedMoney ? (
                <Info>
                  <InfoOr>{result} kWh.</InfoOr> Total $ savings of: <InfoOr>${savedMoney}.</InfoOr>
                </Info>
              ) : null}
            </TextContainer>
          </Left>
          <Vector src={vector} />
          <Right>
            <RightIconContainer>{iconRight ? <Icon src={iconRight.url} /> : null}</RightIconContainer>
            <TextContainer>
              {equivalentValue ? (
                <Info>
                  Equivalent of <InfoGreen>powering {equivalentValue} houses</InfoGreen> for an entire year.
                </Info>
              ) : null}
            </TextContainer>
          </Right>
        </Card>
      </Content>
    </Container>
  )
}
